import React, { useState } from "react";
import './styles/Contact.css';
import { FiMapPin, FiMail, FiPhoneCall, FiBriefcase, FiSend } from "react-icons/fi";

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const name = e.target.name.value;
    const email = e.target.email.value;
    const phone = e.target.phone.value;
    const subject = e.target.subject.value;
    const message = e.target.message.value;

    const whatsappMessage = `Name: ${name}%0AEmail: ${email}%0APhone: ${phone}%0ASubject: ${subject}%0AMessage: ${message}`;
    const companyNumber = "919752791914"; // Replace with actual number

    window.open(`https://wa.me/${companyNumber}?text=${whatsappMessage}`, "");
    setSubmitted(true);
  };

  return (
    <div className="container contact-page py-5">
      <div className="text-center mb-5">
        <h2 className="contact-heading">Contact Us</h2>
        <div className="contact-separator"></div>
      </div>

      <div className="row mb-5 justify-content-center">
        <div className="col-lg-8">
          <div className="contact-form-card p-4 p-md-5 shadow">
            <h4 className="form-title mb-4">Send Us a Message</h4>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="input-group-custom">
                    <input type="text" name="name" required />
                    <label>Name</label>
                    <span className="bar"></span>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="input-group-custom">
                    <input type="email" name="email" required />
                    <label>Email Address</label>
                    <span className="bar"></span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="input-group-custom">
                    <input type="tel" name="phone" required />
                    <label>Phone Number</label>
                    <span className="bar"></span>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="input-group-custom">
                    <input type="text" name="subject" required />
                    <label>Subject</label>
                    <span className="bar"></span>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-4">
                <div className="input-group-custom text-area-group">
                  <textarea name="message" rows="4" required></textarea>
                  <label>Message</label>
                  <span className="bar"></span>
                </div>
              </div>
              <div className="text-center">
                <button type="submit" className="btn-custom py-3 px-5 mt-2">
                  Submit <FiSend />
                </button>
              </div>
              {submitted && <p className="mt-4 text-center text-success fw-bold">Details Sent Successfully!</p>}
            </form>
          </div>
        </div>
      </div>

      {/* Info Blocks */}
      <div className="row g-4 mb-5 info-grid">
        <div className="col-md-4">
          <div className="info-card p-4 text-center h-100 shadow">
            <div className="info-icon">
              <FiMapPin />
            </div>
            <h5>Location</h5>
            <p className="mb-0">Plot no 30,31, Engineering park, Heavy industrial area, Hathkhoj Bhilai (CG) 490023, India</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="info-card p-4 text-center h-100 shadow">
            <div className="info-icon">
              <FiMail />
            </div>
            <h5>Email ID</h5>
            <p className="mb-0">info@reenaindustries.com</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="info-card p-4 text-center h-100 shadow">
            <div className="info-icon">
              <FiPhoneCall />
            </div>
            <h5>Call Us</h5>
            <p className="mb-0">+91 9589161419<br />+91 9752791914</p>
          </div>
        </div>
      </div>

      {/* Careers Section */}
      <div id="careers" className="career-card p-4 p-md-5 text-center shadow scroll-target">
        <div className="career-icon mb-3">
          <FiBriefcase />
        </div>
        <h4 className="mb-3 career-title">Careers</h4>
        <p className="career-desc mx-auto max-w-2xl text-secondary">
          We are always looking for skilled employees such as Mechanical Engineers, Production Supervisors, Fabricators, and Technicians.
          If you are interested in joining Reena Industries, please send your resume to:
        </p>
        <div className="career-email mt-4">
          <a href="mailto:reenaindustries26@gmail.com" className="btn-custom-outline px-4 py-2">
            hr@reenaindustries.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
